import { booleanAttribute, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'glxy-form-row',
  templateUrl: './form-row.component.html',
  styleUrls: ['./form-row.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class FormRowComponent {
  @HostBinding('class') class = 'glxy-form-row';

  @Input({ transform: booleanAttribute })
  @HostBinding('class.top-spacing')
  topSpacing = false;

  @Input({ transform: booleanAttribute })
  @HostBinding('class.bottom-spacing')
  bottomSpacing = false;

  @Input({ transform: booleanAttribute })
  @HostBinding('class.wrap-contents')
  wrapContents = true;
}
